'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.default = pageReducer;

var _actionTypes = require('../actions/action-types');

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {};

/**
 * Reducers api data
 * @param {Object} state of the application
 * @param {Object} action to be trigger
 * @returns {Object}
 */
function pageReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case types.SET_PAGE_DATA:
      return (0, _assign2.default)({}, state, action.data);
    default:
      return state;
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/store/reducers/page-reducer.js
// module id = 121
// module chunks = 35783957827783 71851226274881